// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__SNnax","overflowing":"ReadFullNote_overflowing__2ZDLr"};